export const app = {
  connectToYourWhatsappNumber: 'Connect to your WhatsApp Number',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Connect your WhatsApp Bot with your WhatsApp number',
  connect: 'Connect',
};
